import {Button} from '@primer/react'
import {useRef, useState} from 'react'

import type {IPickerItem, SingleSelectPickerAnchorProps} from './types'

export function SingleSelectPickerAnchor<T extends IPickerItem>(props: SingleSelectPickerAnchorProps<T>) {
  const [isDialogOpen, setDialogOpen] = useState(Boolean(props.isOpenInitially))
  const openDialogButtonRef = useRef<HTMLButtonElement>(null)

  const {selected} = props
  const {
    itemConfig: {
      onRenderItemLeadingVisual,
      onRenderItemName,
      literals: {itemName},
    },
  } = props

  return (
    <>
      <Button
        ref={openDialogButtonRef}
        onClick={() => setDialogOpen(true)}
        leadingVisual={
          selected && onRenderItemLeadingVisual ? (onRenderItemLeadingVisual(selected) as React.ReactElement) : null
        }
        aria-describedby={props['aria-describedby']}
      >
        {selected ? onRenderItemName(selected) : `Select a ${itemName}`}
      </Button>
      {/* eslint-disable-next-line react-hooks/refs */}
      {isDialogOpen && props.renderDialog({onDismiss: () => setDialogOpen(false), returnFocusRef: openDialogButtonRef})}
    </>
  )
}
